import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const moveTypesAdapter = getAdapter({ idFieldName: 'value' });

const moveTypesSlice = createSlice({
  name: 'moveTypes',
  initialState: moveTypesAdapter.getInitialState(),
  reducers: {
    setMoveTypes: (state, { payload: { moveTypes } }) => {
      moveTypesAdapter.setAll(state, moveTypes);
    },
  },
});

const selectors = moveTypesAdapter.getSelectors(({ moveTypes }) => moveTypes);

export const getMoveTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getMoveTypes = (state) => getMoveTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setMoveTypes,
} = moveTypesSlice.actions;

export default moveTypesSlice.reducer;
